export const migrateLocalStorage = (blueprint, objFromStorage) => {
  const result = { ...blueprint }

  for (const key in blueprint) {
    if (objFromStorage.hasOwnProperty(key)) {
      // if key is object (not array) call migrateLocalStorage recursively (needs for nested updates)
      if (
        typeof blueprint[key] === 'object' &&
        !Array.isArray(blueprint[key]) &&
        blueprint[key] !== null &&
        typeof objFromStorage[key] === 'object' &&
        !Array.isArray(objFromStorage[key]) &&
        objFromStorage[key] !== null
      ) {
        result[key] = migrateLocalStorage(blueprint[key], objFromStorage[key])
      } else {
        result[key] = objFromStorage[key]
      }
    }
  }

  return result
}
